// CourseSelectorWithTable.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import StudentList from './Students/StudentsList';

const CourseSelectorWithTable = () => {
  return (
    <div>
      <StudentList/>
    </div>
  );
};

export default CourseSelectorWithTable;
